import { useState } from "react";
import { useQuery } from "react-query";
//primeReact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
//components]
import Panel from "../../../components/panel/panel";
//services
import { Skeleton } from "primereact/skeleton";
import { Link } from "react-router-dom";
import ModalEditEmail from "./ModalEditEmail";
import ModalCreateEmail from "./ModalCreateEmail";
import { getEmailSendGrid } from "../../../services/Enterprise/Email/getEmailSendGrid";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const SendingEmails = () => {
  usePermission("160"); // Configurar Sendgrid
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={`/settings/currentAccount`} className="p-breadcrumb-link">
          Configurar E-mails
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [headerModal] = useState("Cadastrar");
  const [headerEditModal] = useState("Alterar");
  const [loading, setLoading] = useState(false); // Inicialmente, vazio
  const [sendRowData, setSendRowData] = useState([]);
  const [visibleEditModal, setVisibleEditModal] = useState(false);

  const columns = [
    { field: "id", header: "ID" },
    { field: "from_name", header: "Nome para Envio" },
    { field: "from_email", header: "Email de Envio" },
    { field: "reply_to_name", header: "Nome para Resposta" },
    { field: "reply_to", header: "Email de Reposta " },
  ];

  const handleCloseModal = () => {
    setVisible(false);
  };
  const handleCloseEditModal = () => {
    setVisibleEditModal(false);
  };

  function SubmitEditAccount(rowData) {
    setSendRowData(rowData);
    setVisibleEditModal(true);
  }

  //get
  // const {
  //   data: emails,
  //   refetch,
  //   isLoading,
  // } = useQuery({
  //   queryKey: ["emails"],
  //   queryFn: () => getEmailSendGrid(),
  //   enabled: !!permissions.includes("160")
  // });

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-xl-2 col-md-6">
          <Button
            loading={loading}
            rounded
            label="E-mail"
            icon="fa fa-plus"
            onClick={() => setVisible(true)}
            className="p-inputtext-sm me-2 m-auto w-100"
          />
        </div>
      </div>
      <Panel mainCss="mt-4" title="E-mails Cadastrados para Envio">
        {/* {!emails ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            <div className="px-2 pb-3">
              <DataTable
                rows={5}
                paginator
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[5, 25, 100]}
                value={emails}
                totalRecords={emails}
                globalFilter={globalFilterValue}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                <Column
                  header="Ver/Alterar"
                  body={(rowData) => (
                    <div className="text-center">
                      <button
                        disabled={loading}
                        loading={loading}
                        className="btn btn-success btn-btn-sm"
                        onClick={() => SubmitEditAccount(rowData)}
                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </button>
                    </div>
                  )}
                />
              </DataTable>
            </div>
          </>
        )} */}
      </Panel>

      <ModalEditEmail
        visible={visibleEditModal}
        headerModal={headerEditModal}
        handleCloseModal={handleCloseEditModal}
        setVisible={setVisibleEditModal}
        rowData={sendRowData}
        refetch={() => console.log("Essa funcionalidade foi desativada.")}
        loadingAccount={setLoading}
      />

      <ModalCreateEmail
        visible={visible}
        headerModal={headerModal}
        handleCloseModal={handleCloseModal}
        setVisible={setVisible}
        refetch={() => console.log("Essa funcionalidade foi desativada.")}
        loadingAccount={setLoading}
      />
    </>
  );
};

export default SendingEmails;
